<template>
<div class="query-header">
  <el-row
    :gutter="20"
  >
    <el-col
      :lg="8"
      :sm="12"
      :xs="24"
    >
      <div class="label">{{$t('Source_of_rebate')}}</div>
      <el-select
        style="width: 100%"
        :placeholder="$t('please_choose')"
        v-model="type"
        clearable
        @change="toQuery"
      >
        <el-option
          v-for="(item,index) in typeList"
          :key="index"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </el-col>
    <el-col
      :lg="8"
      :sm="12"
      :xs="24"
    >
      <div class="label">{{$t('Opening_time')}}</div>
      <el-date-picker
        v-if="!realMobile"
        style="width: 100%"
        v-model="date"
        @change="toQuery"
        type="daterange"
        value-format="yyyy-MM-dd"
        :range-separator="$t('root.dateTo')"
        :start-placeholder="$t('root.startDate')"
        :end-placeholder="$t('root.endDate')"
      >
      </el-date-picker>
      <select-date-duration
        class="header-sub-item"
        v-model="date"
      ></select-date-duration>
    </el-col>
  </el-row>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { parseTime,init_date } from '@/utils'
export default {
  name: "queryHeader",
  data() {
    let _this = this;
    return {
      type: '',
      typeList: [
        {label: _this.$t('Straight_off'),value: 2},
        {label: _this.$t('sub_IB'),value: 1},
        {label: _this.$t('Myself'),value: 3},
      ],
      date: [], // 时间
    }
  },
  computed: {
    ...mapGetters(['realMobile']),
  },
  created(){
    this.createTime();
  },
  methods: {
    createTime() {
      this.date = [init_date().oneMonAgo,init_date().today];
    },
    toQuery(){
      this.$emit('toQuery', this.type);
    }
  },
}
</script>

<style scoped>

</style>
